<template>
  <div>
    <card v-if="spinning">
      <div class="row">
        <div class="col-md-12 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </card>
    <card>
      <!-- Page Header -->
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />
      <div class="custom-txt ml-1">
        Authentication Group Management
        <el-tooltip content="Add New Authentication Group" placement="top">
          <el-button type="text" @click="openModal('create')">
            <i class="fa-solid fa-circle-plus"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div class="row" style="margin-left: -13px">
        <div class="col-sm-4 mb-1">
          <el-input
            v-model="searchQuery"
            placeholder="Search by Name, Description, or Alias..."
            clearable
          >
            <span slot="prepend">Search</span>
          </el-input>
        </div>
        <el-button
          class="mb-1"
          style="margin-left: -10px"
          @click="searchQuery = ''"
          >Clear</el-button
        >
      </div>
      <el-button type="text" @click="openModal('help')">
        <i class="fa-solid fa-circle-info"></i>
      </el-button>
      <!-- Table for displaying Authentication Groups -->
      <el-table
        :data="paginatedAuthGroups"
        border
        style="width: 100%; margin-top: -35px; z-index: 0"
      >
        <el-table-column
          class="center-content"
          label="Assign"
          width="150"
          :header-align="headerAlignCenter"
        >
          <template slot-scope="scope">
            <div class="center-content">
              <el-tooltip content="Assign Users" placement="top">
                <el-button type="text" @click="openAssignDialog(scope.row)">
                  <i class="fa-solid fa-users"></i>
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="Name"
          :header-align="headerAlignCenter"
        >
          <template #default="scope">
            <fg-input
              type="text"
              v-model="scope.row.name"
              @input="debouncedUpdateName(scope.row.id, scope.row.name)"
            ></fg-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="Description"
          :header-align="headerAlignCenter"
        >
          <template #default="scope">
            <fg-input
              type="text"
              v-model="scope.row.description"
              @input="
                debouncedUpdateDescription(scope.row.id, scope.row.description)
              "
            ></fg-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="alias"
          label="Alias"
          :header-align="headerAlignCenter"
        >
          <template #default="scope">
            <fg-input
              type="text"
              v-model="scope.row.alias"
              @input="debouncedUpdateAlias(scope.row.id, scope.row.alias)"
            ></fg-input>
          </template>
        </el-table-column>
        <el-table-column
          label="Actions"
          width="150"
          :header-align="headerAlignCenter"
        >
          <template #default="scope">
            <div class="center-content">
              <!--<el-tooltip content="Update Authentication Group" placement="top">
              <el-button type="text" @click="updateGroup(scope.row)">
                <i class="fa-regular fa-floppy-disk"></i>
              </el-button>
            </el-tooltip>-->
              <el-tooltip content="Delete Authentication Group" placement="top">
                <el-button type="text" @click="deleteGroup(scope.row)">
                  <el-icon name="delete" class="icon-large icon-red"></el-icon>
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      >
      </el-pagination>
    </card>
    <el-dialog
      center
      title="Confirm Deletion of Auth Group"
      :visible.sync="modals.basic"
    >
      <span
        >Are you sure you want to delete the auth group:
        {{ delete_authgroup_name }}?</span
      >
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('basic')">
          Cancel</button
        >&nbsp;
        <button class="btn btn-success" @click="deleteAuthGroup">
          Confirm
        </button>
      </span>
    </el-dialog>
    <el-dialog center title="Success" :visible.sync="modals.success">
      <div class="text-center">
        <span>Success: {{ success_txt }}</span>
        <div class="text-center mt-4">
          <span slot="footer">
            <l-button
              round
              type="btn btn-success"
              class="mt-4"
              @click="closeModal('success')"
              >OK</l-button
            >&nbsp;
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog center title="Error" :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <div class="text-center mt-4">
          <span slot="footer" class="dialog-footer">
            <l-button type="btn btn-danger" round @click="closeModal('error')"
              >OK</l-button
            >&nbsp;
          </span>
        </div>
      </div>
    </el-dialog>
    <!-- Dialog for creating a new Authentication Group -->
    <el-dialog :visible.sync="modals.create" width="50%">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-center">
            <h3 style="margin-top: -15px">Create an Authentication Group</h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <fg-input
            label="Name:"
            placeholder="Name"
            v-model="newGroup.name"
          ></fg-input>
        </div>
        <div class="col-sm-4">
          <fg-input
            label="Description:"
            placeholder="Description"
            v-model="newGroup.description"
          ></fg-input>
        </div>
        <div class="col-sm-4">
          <fg-input
            label="Alias"
            placeholder="Alias"
            v-model="newGroup.alias"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center">
          <button
            :disabled="
              !newGroup.name || !newGroup.description || !newGroup.alias
            "
            class="btn-blue btn-round mr-1"
            @click="createAuthGroup"
          >
            Save
          </button>
          <button class="btn-red btn-round" @click="closeModal('create')">
            Cancel
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="modals.users" width="45%">
      <div class="text-center">
        <div class="row" style="margin-top: -10px">
          <div class="col-sm-12 mb-4">
            <h3 style="margin-top: -20px">
              {{
                `Assign Users to ${selectedAuthGroup ? selectedAuthGroup.name : ""}`
              }}
            </h3>
          </div>
        </div>
      </div>
      <div class="ml-5">
        <el-transfer
          class="custom-transfer"
          v-model="selectedUsers"
          :data="transferData"
          :titles="['Available Users', 'Assigned Users']"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="Search for a user"
        >
        </el-transfer>
      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-sm-12 text-center">
          <button
            type="button"
            class="btn-blue btn-round mr-1"
            @click="assignUsersToGroup"
          >
            Save
          </button>
          <button
            type="button"
            class="btn-red btn-round"
            @click="closeModal('users')"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="modals.help">
      <div class="row" style="margin-top: -30px">
        <div class="col-sm-12 text-center custom-txt">
          Authentication Group Management
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          Here, you can view a full list of all authentication groups within
          your system.
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          <span style="font-weight: bold">Search Table:</span>
          You can search the table by auth group name, description or alias.
          Find and click the search bar just above the table, and enter the
          value you would like to find within the table. The table will filter
          accordingly. In order to clear your search, click the button labeled
          'Clear' next to the search bar. The table will return to all original
          values.
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          <span style="font-weight: bold"
            >Adding Auth Groups
            <i class="fa-solid fa-circle-plus" style="font-size: 17px"></i>
          </span>
          To add an auth group, start by clicking the green plus button at the
          top of the page. Then enter your auth group's name, description and
          alias. These fields are required, if you do not fill them all out
          accordingly, your authentication group will not be created. When you
          are finished, click the blue button labeled 'Save' in order to create
          your auth group. If you do not want to create the group click the red
          button labeled 'Cancel' to stop the operation.
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          <span style="font-weight: bold"
            >Assigning Users to Auth Groups <i class="fa-solid fa-users"></i>
          </span>
          To assign users to authentication groups, begin by clicking the green
          users button within the 'Assign' column. Ensure you are clicking the
          users button that is in the same row as the authentication group you
          would like to assign users to. Then select your users from the list on
          the left side, by clicking the box next to the user's name. Once you
          have selected all users you would like to assign to an auth group,
          click the arrow pointing right to the second list to assign the users
          to your selected authentication group. When you are finished assigning
          your users, click the blue button labeled 'Save' in order to assign
          the users. If you do not want to assign users, click the red button
          labeled 'Cancel' to stop the operation.
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          <span style="font-weight: bold">Updating Auth Groups:</span>
          To update an auth group, simply click whichever value you would like
          to change and begin typing. Your system will update and save these
          changes automatically.
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center help-txt">
          <span style="font-weight: bold"
            >Deleting Auth Groups
            <el-icon name="delete" class="icon-red"></el-icon>
          </span>
          To delete an authentication group, click the red trash can button
          within the 'Actions' column. Before you delete an auth group, ensure
          you are clicking the trash can that is in the same row as the auth
          group you would like to delete. Once an auth group is deleted, the
          only way to retrieve it is to create it again.
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12 text-center">
          <button
            type="button"
            class="btn-blue btn-round"
            @click="closeModal('help')"
          >
            Close
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { BSpinner } from "bootstrap-vue";
import {
  Transfer,
  Checkbox,
  Input,
  Dialog,
  Button,
  Table,
  TableColumn,
  Tooltip,
  Icon,
  Pagination,
  Message,
} from "element-ui";
import { UsersAPIService } from "src/servicehandlers/UsersAPIService";

import AuthGroupAPIService from "../../../../servicehandlers/AuthGroupAPIService";
const usersAPIService = new UsersAPIService();
const authGroupAPIService = new AuthGroupAPIService();

export default {
  name: "UserAuthgroupsAdmin",
  components: {
    [Transfer.name]: Transfer,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [Input.name]: Input,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Icon.name]: Icon,
    [Pagination.name]: Pagination,
    [Message.name]: Message,
    BSpinner,
  },
  data() {
    return {
      searchQuery: "",
      selected_authgroups: [],
      stringItem: "",
      headerAlignCenter: "center",
      currentPage: 1,
      perPage: 50,
      pageSize: 20,
      pageSizes: [20, 50, 100, 200, 500, 1000],
      totalItems: 0,
      modals: {
        error: false,
        success: false,
        create: false,
        users: false,
        help: false,
      },
      newGroup: {
        name: "",
        description: "",
        alias: "",
      },
      filteredGroups: [],
      transferData: [],
      filteredUserOptions: [],
      filterUserOptions: "",
      searchUserTerm: null,
      users: [],
      authgroup_name: null,
      showUserDialog: false,
      selectedAuthGroup: null,
      selectedUsers: [],
      authGroups: [],
      delete_authgroup_id: null,
      delete_authgroup_name: null,
      lastSelectItem: null,
      selected_auth_group_ids: [],
      selected_user_id: null,
      selected_authgroup_id: null,
      results: false,
      result_txt: "",
      success_txt: "",
      error_txt: null,
      spinning: false,
    };
  },
  watch: {
    filteredAuthGroups: {
      handler(newVal) {
        this.totalItems = newVal.length;
      },
      immediate: true,
    },
  },
  async created() {
    await this.getAllAuthGroups();
    await this.getAllUsers();
    this.filteredGroups = this.authGroups;

    // Set transferData to represent all users
    this.transferData = this.users.map((user) => ({
      key: user.id,
      label: `${user.firstName} ${user.lastName}`,
    }));
  },
  computed: {
    paginatedAuthGroups() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = this.currentPage * this.pageSize;
      return this.filteredAuthGroups.slice(start, end);
    },
    filteredAuthGroups() {
      return this.authGroups.filter(
        (group) =>
          (group.name
            ? group.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            : false) ||
          (group.description
            ? group.description
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
            : false) ||
          (group.alias
            ? group.alias.toLowerCase().includes(this.searchQuery.toLowerCase())
            : false),
      );
    },
  },
  mounted() {},
  methods: {
    filterMethod(query, item) {
      return item.label.toLowerCase().includes(query.toLowerCase());
    },
    async openAssignDialog(authGroup) {
      this.selectedAuthGroup = authGroup;

      // Reset selectedUsers
      this.selectedUsers = [];

      try {
        let allAuthgroups = await authGroupAPIService.getAuthGroupsWithUsers(
          authGroup.id,
          this.$router,
        );

        // Populate selectedUsers with the IDs of the users for the current authGroup
        this.selectedUsers = allAuthgroups.users.map((user) => user.id);

        this.openModal("users");
      } catch (error) {
        this.handleError(
          "Error: could not assign or get groups with users!" + error,
        );
      }
    },
    assignUsersToGroup() {
      this.selectedAuthGroup.users = [...this.selectedUsers];
      this.closeModal("users");

      const params = {
        user_ids: this.selectedUsers,
        auth_group_id: this.selectedAuthGroup.id,
      };
      // now assign the users
      return authGroupAPIService
        .linkAuthgroupToUsers(params, this.$router)
        .then(() => {
          this.handleSuccess("Successfully linked users to auth group!");
        })
        .catch((error) => {
          this.handleError("Failed to link users to auth group! " + error);
        });
    },
    debouncedUpdateName: debounce(function (id, name) {
      this.updateName(id, name);
    }, 500),

    updateName(id, name) {
      const group_name = {
        name,
      };
      return authGroupAPIService
        .updateAuthGroup(id, group_name, this.$router)
        .then(() => {
          this.success_txt = "Successfully updated name";
          Message.success("Successfully updated name");
          // this.getAccounts();
        })
        .catch((error) => {
          this.error_txt = "Failed to update name: " + error;
          this.handleError();
        });
    },
    debouncedUpdateDescription: debounce(function (id, description) {
      this.updateDescription(id, description);
    }, 500),

    updateDescription(id, description) {
      const group_description = {
        description,
      };
      return authGroupAPIService
        .updateAuthGroup(id, group_description, this.$router)
        .then(() => {
          this.success_txt = "Successfully updated description";
          Message.success("Successfully updated description");
          // this.getAccounts();
        })
        .catch((error) => {
          this.error_txt = "Failed to update description: " + error;
          this.handleError();
        });
    },
    debouncedUpdateAlias: debounce(function (id, alias) {
      this.updateAlias(id, alias);
    }, 500),

    updateAlias(id, alias) {
      const group_alias = {
        alias,
      };
      return authGroupAPIService
        .updateAuthGroup(id, group_alias, this.$router)
        .then(() => {
          this.success_txt = "Successfully updated alias";
          Message.success("Successfully updated alias");
          // this.getAccounts();
        })
        .catch((error) => {
          this.error_txt = "Failed to update alias: " + error;
          this.handleError();
        });
    },
    /*updateGroup(row) {
      return authGroupAPIService.updateAuthGroup(this.$router, row.id, row)
      .then(() => {
        this.handleSuccess('Successfully update authentication group!');
      })
      .catch((error) => {
        this.handleError('Error updating authentication group!: ' + error);
      });
    },*/
    deleteGroup(row) {
      // Implement logic to delete the group
      const index = this.authGroups.findIndex((group) => group.id === row.id);
      if (index > -1) {
        this.authGroups.splice(index, 1);
      }
      return authGroupAPIService
        .deleteAuthGroup(this.$router, row.id)
        .then(() => {
          this.handleSuccess("Successfully deleted authentication group!");
        })
        .catch((error) => {
          this.handleError("Error deleting authentication group!: " + error);
        });
    },
    handleRowClick(row, column, event) {},
    assignUsers(index, row) {
      // Implement your logic for assigning users here
    },
    handleSelectedAuthGroups(values) {
      this.selected_auth_group_ids = values;
    },
    preDeleteAuthgroup(group_id, group_name) {
      this.delete_authgroup_name = group_name;
      this.delete_authgroup_id = group_id;
      this.openModal("basic");
    },
    deleteAuthGroup() {
      this.closeModal("basic");
      this.spinning = true;
      if (!this.delete_authgroup_id) {
        this.error_txt = "No Authgroup was selected!";
        this.openModal("error");
        this.spinning = false;
        return;
      }

      return authGroupAPIService
        .deleteAuthGroup(this.$router, this.delete_authgroup_id)
        .then(() => {
          this.getAllAuthGroups();
          this.success_txt = "Successfully deleted authgroup!";
          this.openModal("success");
          this.selected_authgroup_id = null;
          this.spinning = false;
        })
        .catch((error) => {
          this.error_txt = "Authgroup deletion failed: " + error;
          this.openModal("error");
          this.spinning = false;
        });
    },
    createAuthGroup() {
      this.spinning = true;
      if (!this.newGroup.name) {
        this.error_txt = "No auth group name input!";
        this.openModal("error");
        this.spinning = false;
        return;
      }
      this.closeModal("create");

      return authGroupAPIService
        .addAuthGroup(this.$router, this.newGroup)
        .then((authgroup) => {
          this.getAllAuthGroups();
          this.handleSuccess("Successfully created group: " + authgroup.name);
          this.newGroup = { name: "", description: "", alias: "" }; // Reset the object for future use.
          this.authgroup_name = null;
        })
        .catch((error) => {
          this.handleError("Error creating auth group: " + error);
        });
    },
    save() {
      this.spinning = true;
      // save the IDS to the database for the user
      if (!this.selected_user_id) {
        this.error_txt = "No user selected!";
        this.openModal("error");
        this.spinning = false;
        return;
      }
      if (this.selected_auth_group_ids.length <= 0) {
        this.error_txt = "No auth groups selected!";
        this.openModal("error");
        this.spinning = false;
        return;
      }
      return authGroupAPIService
        .addUserToAuthGroups(
          this.selected_user_id,
          this.selected_auth_group_ids,
          this.$router,
        )
        .then(() => {
          this.success_txt = "Successfully updated groups for user";
          this.openModal("success");
          this.spinning = false;
        })
        .catch((error) => {
          this.spinning = false;
          this.error_txt = "Error saving users to groups: " + error;
          this.openModal("error");
        });
    },
    clear() {
      this.selected_user_id = null;
      this.selected_auth_group_ids = [];
    },
    onSelect(items, lastSelectItem) {
      this.selected_auth_group_ids = items;
      this.lastSelectItem = lastSelectItem;
    },
    async getAllUsers() {
      this.spinning = true;
      return await usersAPIService
        .get(this.$router)
        .then((allUsers) => {
          for (const user of allUsers) {
            user.text = user.lastName + ", " + user.firstName;
            user.value = user.id;
          }
          this.users = allUsers;
          this.filteredUserOptions = allUsers;
          this.spinning = false;
        })
        .catch((error) => {
          this.spinning = false;
          this.error_txt = error;
          this.openModal("error");
        });
    },

    selectUser() {
      // get the full user by ID with scopes, etc, from the DB
      this.spinning = true;
      return usersAPIService
        .getUserWithAuthGroups(this.selected_user_id, this.$router)
        .then((selectedUser) => {
          this.selected_auth_group_ids = [];
          this.spinning = false;
          const authGroups = selectedUser.auth_groups;
          for (const group of authGroups) {
            group.text = group.name;
            group.value = group.id;
            this.selected_auth_group_ids.push(group.id);
          }
        })
        .catch((error) => {
          this.spinning = false;
          this.error_txt = "Error getting user from DB: " + error;
          this.openModal("error");
        });
    },

    async getAllAuthGroups() {
      this.spinning = true;
      return await authGroupAPIService
        .getAuthGroups(this.$router)
        .then((agps) => {
          this.authGroups = agps;
          for (const group of this.authGroups) {
            group.text = group.name;
            group.value = group.id;
          }
          this.spinning = false;
        })
        .catch((error) => {
          this.error_txt = error;
          this.spinning = false;
          this.openModal("error");
        });
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    openModal(name) {
      this.modals[name] = true;
    },
    handleSuccess(text) {
      this.success_txt = text;
      this.openModal("success");
      this.spinning = false;
      setTimeout(() => {
        this.modals["success"] = false;
      }, 1500); // Hide after 1.5 secs
    },
    handleError(error) {
      this.error_txt = error;
      this.openModal("error");
      this.spinning = false;
      setTimeout(() => {
        this.modals["error"] = false;
      }, 1500); // Hide after 1.5 secs
    },
    addNewGroup() {
      // Assuming 'id' is needed, auto-increment or generate the ID as needed.
      this.newGroup.id = Date.now(); // Simplistic ID generation; you might want to improve this.
      this.authGroups.push(this.newGroup);
      this.showDialog = false;
      this.newGroup = { name: "", description: "", alias: "" }; // Reset the object for future use.
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
  },
};
</script>

<style scoped>
.header {
  padding: 20px;
  text-align: center;
  color: black;
}

.table-header {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  align-items: center;
}

.row {
  margin: 10px 0;
}
.form-group {
  margin-bottom: 15px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.user-row {
  margin: 10px 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.el-dialog__header {
  text-align: center;
  font-size: 24px; /* adjust size as needed */
}
.custom-header {
  color: dimgrey;
  font-size: 25px;
  text-align: left;
  margin-top: 5px;
  margin-left: 15px;
}
.fa-users {
  color: mediumseagreen;
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fa-floppy-disk {
  font-size: 19px;
  color: dodgerblue;
}
.small-select {
  width: 300px;
}
.custom-txt {
  font-size: 23px;
  color: dimgrey;
  margin-left: -10px;
}
.fa-circle-info {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 18px;
}
.help-txt {
  word-break: keep-all;
  font-size: 15px;
}
.btn-blue {
  color: white;
  background-color: dodgerblue;
  border: none;
}
.btn-red {
  color: white;
  background-color: red;
  border: none;
}
.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 8px 16px;
}
button {
  //border: none;
}
.disabled {
  cursor: not-allowed;
}
.fa-circle-plus {
  font-size: 21px;
  color: mediumseagreen;
}
.icon-red {
  color: red;
  font-size: 20px;
}
</style>
